import { t } from 'utils/i18n';

export interface IStatus {
  [key: string]: string | number | boolean;
}
export enum COURSE_ISSUE {
  NONE = 'none',
  OTHER = 'other',
  TEACHER_TAKE_LEAVE = 'teacherTakeLeave',
  STUDENT_TAKE_LEAVE = 'studentTakeLeave',
  STUDENT_ASK_TRANSFER = 'studentAskTransfer',
  STUDENT_ASK_SUBSTITUTE = 'studentAskSubstitute',
  STUDENT_ASK_CANCEL = 'studentAskCancel',
  TEACHER_ABSENTEEISM = 'teacherAbsenteeism',
  TEACHER_LATE = 'teacherLate',
  TEACHER_LEAVE_EARLY = 'teacherLeaveEarly',
  STUDENT_ABSENTEEISM = 'studentAbsenteeism',
  STUDENT_LATE = 'studentLate',
  STUDENT_LEAVE_EARLY = 'studentLeaveEarly',
  TOO_SHORT_COURSE = 'tooShortCourse',
  TOO_LONG_COURSE = 'tooLongCourse',
  STUDENT_TAKE_LEAVE_WITHIN_8_HOURS = 'studentTakeLeaveWithin8Hours',
  /** 原民會學生 8 小時內無法到課：課程不取消，照正常課程流程進行 */
  STUDENT_TAKE_LEAVE_WITHIN_8_HOURS_BY_CIP = 'studentTakeLeaveWithin8HoursByCip',
  TEACHER_TAKE_LEAVE_TOO_LATE = 'teacherTakeLeaveTooLate',
  /** 原民會學生 8 小時內無法到課，且老師無法到課：課程取消，異常完課 */
  TEACHER_TAKE_LEAVE_BY_CIP = 'teacherTakeLeaveByCip',
  /** 原民會學生 8 小時內無法到課，且老師臨時無法到課：課程取消，異常完課 */
  TEACHER_TAKE_LEAVE_TOO_LATE_BY_CIP = 'teacherTakeLeaveTooLateByCip',
  STUDENT_TAKE_LEAVE_TOO_LATE = 'studentTakeLeaveTooLate',
  ANOMALY = 'anomaly',
  VIDEO_RECORD_NOT_WORK = 'videoRecordNotWork',
  VIDEO_RECORD_TOO_SHORT = 'videoRecordTooShort',
  VIDEO_RECORD_TOO_LONG = 'videoRecordTooLong',
}

export enum COURSE_STATUS_KEY {
  /** 待回覆 */
  NO_REPLY = 'noReply',
  /** 已排課 */
  CONFIRM = 'confirm',
  /** 已完成 */
  COMPLETE = 'complete',
  /** 待處理 */
  DEALING = 'dealing',
  /** 已取消 */
  CANCEL = 'cancel',
}

export const COURSE_STATUS_LABEL = {
  [COURSE_STATUS_KEY.NO_REPLY]: {
    description: t(
      'constants.course.courseStatus.noReplyDescription',
      '待回覆',
    ),
    style: {
      fontWeight: '700',
      fontSize: '14px',
      padding: '1px 8px',
      color: '#74B71E',
      background: '#FFFFFF',
      border: '1px solid #74B71E',
      borderRadius: '6px',
      mr: '0.75rem',
    },
  },
  [COURSE_STATUS_KEY.CONFIRM]: {
    description: t(
      'constants.course.courseStatus.confirmDescription',
      '已排課',
    ),
    style: {
      fontWeight: '700',
      fontSize: '14px',
      padding: '1px 8px',
      color: '#46830F',
      background: 'rgba(116, 183, 30, 0.16)',
      borderRadius: '6px',
      mr: '0.75rem',
    },
  },
  [COURSE_STATUS_KEY.COMPLETE]: {
    description: t(
      'constants.course.courseStatus.completeDescription',
      '已完成',
    ),
    style: {
      fontWeight: '700',
      fontSize: '14px',
      padding: '1px 8px',
      color: '#015FA8',
      background: 'rgba(2, 164, 234, 0.16)',
      borderRadius: '6px',
      mr: '0.75rem',
    },
  },
  [COURSE_STATUS_KEY.DEALING]: {
    description: t(
      'constants.course.courseStatus.dealingDescription',
      '待處理',
    ),
    style: {
      fontWeight: '700',
      fontSize: '14px',
      padding: '1px 8px',
      color: '#FF5630',
      border: '1px solid #FF5630',
      background: 'transparent',
      borderRadius: '6px',
      mr: '0.75rem',
    },
  },
  [COURSE_STATUS_KEY.CANCEL]: {
    description: t('constants.course.courseStatus.cancelDescription', '已取消'),
    style: {
      fontWeight: '700',
      fontSize: '14px',
      padding: '1px 8px',
      color: '#B78103',
      background: 'rgba(249, 200, 2, 0.16)',
      borderRadius: '8px',
      mr: '0.75rem',
    },
  },
} as const;

export enum COURSE_STATUS {
  DRAFT = 'draft',
  PUBLISH = 'publish',
  FINISH = 'finish',
  CANCEL = 'cancel',
}

export enum COURSE_TEACHER_STATUS {
  REPLY = 'reply', // waiting for reply
  ACCEPT = 'accept', // accept
  REJECT = 'reject', // reject
}

export enum COURSE_INTERVAL_STATUS {
  /** 草稿 */
  DRAFT = 'draft',
  /** 預備區 */
  PREP = 'prep',
  /** 準備中 */
  PREPARING = 'preparing',
  /** 進行中 */
  PROCESSING = 'processing',
  /** 完課 其他未填完 */
  OVER = 'over',
  /** 已取消 */
  CANCEL = 'cancel',
  /** 全部完課(審核完課後回饋) */
  FINISH = 'finish',
}

export enum COURSE_FEEDBACK_STATUS {
  NONE = 'none',
  PENDING = 'pending',
  AUDITED = 'audited',
}
/**
 * @param None No abnormality
 * @param Other
 * @param TeachertakeLeave
 * @param StudenttakeLeave Student leave (Student Cancel Course)
 * @param Studentasktransfer Student requesting a class
 * @param Studentasksubstitute Student requesting classes
 * @param Studentaskcancel Teacher to ask for leave-> Students ask for cancellation
 * @param Teacherabsenteeism
 * @param TeacherLate Teacher Late
 * @param TeacherLaveEarly Early leave
 * @param StudentabSeneteeism students
 * @param Studentlate students are late
 * @param Studentleaveearly Student Student Student Early
 * @param Tooshortcourse Course is too short
 * @param Toolongcourse Course
 * @param TeachertakeLaVetoolate Teacher to ask for leave at 24:00
 * @param StudenttakeleaveToolate students ask for leave at 24:00
 * @param Anomaly is abnormal in class time
 * @param VideoRCORDNOTWORK video is not started
 * @param VideoCordtooshort Video is too short
 * @param VideoRCORDTOOLONG video is too long
 */
export const COURSE_ISSUE_DESCRIPTION = {
  [COURSE_ISSUE.NONE]: t('constants.course.courseIssues.none', '無'),
  [COURSE_ISSUE.OTHER]: t('constants.course.courseIssues.other', '其他'),
  [COURSE_ISSUE.TEACHER_TAKE_LEAVE]: t(
    'constants.course.courseIssues.teacherLeave',
    '老師無法到課',
  ),
  [COURSE_ISSUE.STUDENT_TAKE_LEAVE]: t(
    'constants.course.courseIssues.studentLeave',
    '學生無法到課',
  ),
  [COURSE_ISSUE.STUDENT_ASK_SUBSTITUTE]: t(
    'constants.course.courseIssues.studentAskSubstitute',
    '學生要求代課',
  ),
  [COURSE_ISSUE.STUDENT_ASK_TRANSFER]: t(
    'constants.course.courseIssues.studentAskTransfer',
    '學生請求調課',
  ),
  [COURSE_ISSUE.STUDENT_ASK_CANCEL]: t(
    'constants.course.courseIssues.studentAskCancel',
    '老師無法到課，學生要求取消',
  ),
  [COURSE_ISSUE.TEACHER_ABSENTEEISM]: t(
    'constants.course.courseIssues.teacherAbsenteeism',
    '老師曠課',
  ),
  [COURSE_ISSUE.TEACHER_LATE]: t(
    'constants.course.courseIssues.teacherLate',
    '老師遲到',
  ),
  [COURSE_ISSUE.TEACHER_LEAVE_EARLY]: t(
    'constants.course.courseIssues.teacherLeaveEarly',
    '老師早退',
  ),
  [COURSE_ISSUE.STUDENT_ABSENTEEISM]: t(
    'constants.course.courseIssues.studentAbsenteeism',
    '學生曠課',
  ),
  [COURSE_ISSUE.STUDENT_LATE]: t(
    'constants.course.courseIssues.studentLate',
    '學生遲到',
  ),
  [COURSE_ISSUE.STUDENT_LEAVE_EARLY]: t(
    'constants.course.courseIssues.studentLeaveEarly',
    '學生早退',
  ),
  [COURSE_ISSUE.TOO_SHORT_COURSE]: t(
    'constants.course.courseIssues.tooShortCourse',
    '課程過短',
  ),
  [COURSE_ISSUE.TOO_LONG_COURSE]: t(
    'constants.course.courseIssues.tooLongCourse',
    '課程超時',
  ),
  [COURSE_ISSUE.STUDENT_TAKE_LEAVE_WITHIN_8_HOURS]: t(
    'constants.course.courseIssues.studentLeaveWithin8Hours',
    '學生於8小時內無法到課',
  ),
  [COURSE_ISSUE.STUDENT_TAKE_LEAVE_WITHIN_8_HOURS_BY_CIP]: t(
    'constants.course.courseIssues.studentLeaveWithin8HoursByCip',
    '學生 8 小時內無法到課 (原民會)',
  ),
  [COURSE_ISSUE.TEACHER_TAKE_LEAVE_TOO_LATE]: t(
    'constants.course.courseIssues.teacherLeaveTooLate',
    '老師於24時內無法到課',
  ),
  [COURSE_ISSUE.TEACHER_TAKE_LEAVE_BY_CIP]: t(
    'constants.course.courseIssues.teacherLeaveByCip',
    '學生 8 小時內無法到課 (原民會) 且老師無法到課',
  ),
  [COURSE_ISSUE.TEACHER_TAKE_LEAVE_TOO_LATE_BY_CIP]: t(
    'constants.course.courseIssues.teacherLeaveTooLateByCip',
    '學生 8 小時內無法到課 (原民會) 且老師臨時無法到課',
  ),
  [COURSE_ISSUE.STUDENT_TAKE_LEAVE_TOO_LATE]: t(
    'constants.course.courseIssues.studentLeaveTooLate',
    '學生於24時內無法到課',
  ),
  [COURSE_ISSUE.ANOMALY]: t(
    'constants.course.courseIssues.anomaly',
    '上課時間異常',
  ),
  [COURSE_ISSUE.VIDEO_RECORD_NOT_WORK]: t(
    'constants.course.courseIssues.videoRecordNotWork',
    '錄影沒有啟動',
  ),
  [COURSE_ISSUE.VIDEO_RECORD_TOO_SHORT]: t(
    'constants.course.courseIssues.videoRecordTooShort',
    '錄影太短',
  ),
  [COURSE_ISSUE.VIDEO_RECORD_TOO_LONG]: t(
    'constants.course.courseIssues.videoRecordTooLong',
    '錄影太長',
  ),
} as const;

export const NEED_SHOW_COURSE_ISSUE = [
  COURSE_ISSUE.OTHER,
  COURSE_ISSUE.TEACHER_TAKE_LEAVE,
  // COURSE_ISSUE.STUDENT_TAKE_LEAVE,
  // COURSE_ISSUE.STUDENT_ASK_TRANSFER,
  // COURSE_ISSUE.STUDENT_ASK_SUBSTITUTE,
  // COURSE_ISSUE.STUDENT_ASK_CANCEL,
  COURSE_ISSUE.TEACHER_ABSENTEEISM,
  COURSE_ISSUE.TEACHER_LATE,
  // COURSE_ISSUE.STUDENT_ABSENTEEISM,
  // COURSE_ISSUE.STUDENT_LATE,
  // COURSE_ISSUE.STUDENT_LEAVE_EARLY,
  COURSE_ISSUE.TEACHER_TAKE_LEAVE_TOO_LATE,
  // COURSE_ISSUE.STUDENT_TAKE_LEAVE_TOO_LATE,
  COURSE_ISSUE.VIDEO_RECORD_NOT_WORK,
  COURSE_ISSUE.STUDENT_TAKE_LEAVE_WITHIN_8_HOURS_BY_CIP,
  COURSE_ISSUE.TEACHER_TAKE_LEAVE_BY_CIP,
  COURSE_ISSUE.TEACHER_TAKE_LEAVE_TOO_LATE_BY_CIP,
] as const;

/** 不影響正常課程流程的 issue：課程標籤照正常課顯示，老師也可照常請假 */
export const NORMAL_FLOW_COURSE_ISSUE: readonly COURSE_ISSUE[] = [
  COURSE_ISSUE.STUDENT_TAKE_LEAVE_WITHIN_8_HOURS_BY_CIP,
];

export enum ECOURSE_TYPE {
  INDIVIDUAL_LIVE_COURSE = 'individualLiveCourse',
  GROUP_LIVE_COURSE = 'groupLiveCourse',
  EXTRACURRICULAR = 'extracurricular',
  INDIVIDUAL_CAMBRIDGE = 'individualCambridge',
  INDIVIDUAL_TUTORIAL_CENTER_COURSE = 'individualTutorialCenterCourse',
  GROUP_TUTORIAL_CENTER_COURSE = 'groupTutorialCenterCourse',
  INDIVIDUAL_LEARNING_BAR_COURSE = 'individualLearningBarCourse',
  INDIVIDUAL_TUTORIAL_CENTER_PLUS_COURSE = 'individualTutorialCenterPlusCourse', // 一對一補習班課 toB(Link+)
  GROUP_TUTORIAL_CENTER_PLUS_COURSE = 'groupTutorialCenterPlusCourse', // 團體補習班課 toB(Link+)
  LEARNING_BAR_PLUS = 'individualLearningBarPlusCourse', // 學bar個人課 toB(Link+)
  GROUP_LEARNING_BAR_PLUS = 'groupLearningBarPlusCourse', // 學bar團體課 toB(Link+)
  PUBLIC_LIVE_STREAMING_COURSE = 'publicLiveStreamingCourse', // 公開直播課
  /** 小堂數 */
  SHORT_TERM_COURSE = 'shortTermCourse',
  INDIVIDUAL_CIP_COURSE = 'individualCipCourse',
}

export const ECOURSE_TYPE_TEXT: IStatus = {
  [ECOURSE_TYPE.INDIVIDUAL_LIVE_COURSE]: t(
    'constants.course.eCourseTypeText.individualLiveCourse',
    '家教個人課',
  ),
  [ECOURSE_TYPE.GROUP_LIVE_COURSE]: t(
    'constants.course.eCourseTypeText.groupLiveCourse',
    '家教團體課',
  ),
  [ECOURSE_TYPE.EXTRACURRICULAR]: t(
    'constants.course.eCourseTypeText.extracurricular',
    '課外學習',
  ),
  [ECOURSE_TYPE.INDIVIDUAL_CAMBRIDGE]: t(
    'constants.course.eCourseTypeText.individualCambridge',
    '劍橋英檢1對1',
  ),
  [ECOURSE_TYPE.INDIVIDUAL_TUTORIAL_CENTER_COURSE]: t(
    'constants.course.ecourseTypeText.individualTutorialCenterCourse',
    '補習班個人課',
  ),
  [ECOURSE_TYPE.GROUP_TUTORIAL_CENTER_COURSE]: t(
    'constants.course.ecourseTypeText.groupTutorialCenterCourse',
    '補習班團體課',
  ),
  [ECOURSE_TYPE.INDIVIDUAL_LEARNING_BAR_COURSE]: t(
    'constants.course.ecourseTypeText.individualLearningBarCourse',
    '學bar個人課',
  ),
  [ECOURSE_TYPE.INDIVIDUAL_TUTORIAL_CENTER_PLUS_COURSE]: t(
    'constants.course.ecourseTypeText.individualTutorialCenterCourse',
    '補習班個人課',
  ),
  [ECOURSE_TYPE.GROUP_TUTORIAL_CENTER_PLUS_COURSE]: t(
    'constants.course.ecourseTypeText.groupTutorialCenterCourse',
    '補習班團體課',
  ),
  [ECOURSE_TYPE.LEARNING_BAR_PLUS]: t(
    'constants.course.ecourseTypeText.individualLearningBarCourse',
    '學bar個人課',
  ),
  [ECOURSE_TYPE.GROUP_LEARNING_BAR_PLUS]: t(
    'constants.course.ecourseTypeText.groupLearningBarCourse',
    '學Bar團體課',
  ),
  [ECOURSE_TYPE.PUBLIC_LIVE_STREAMING_COURSE]: t(
    'constants.course.ecourseTypeText.publicLiveStreamingCourse',
    '公開直播課',
  ),
  [ECOURSE_TYPE.SHORT_TERM_COURSE]: t(
    'constants.course.ecourseTypeText.shortTermCourse',
    'OneClass Now 個人課',
  ),
  [ECOURSE_TYPE.INDIVIDUAL_CIP_COURSE]: t(
    'constants.course.ecourseTypeText.individualCipCourse',
    '原民 1 對 1',
  ),
};

export enum ESTATUS_TAG {
  UNDER_REVIEW = 'underReview',
  INCOMING = 'incoming',
  WAITING_GIVE_BACK = 'waitingGiveBack',
}

export interface IStatusTagBox {
  [key: string]: {
    key: string;
    description: string;
    style: {
      backgroundColor: string;
      color: string;
    };
  };
}

export const ESTATUS_TAG_BOX: IStatusTagBox = {
  [ESTATUS_TAG.UNDER_REVIEW]: {
    key: 'underReview',
    description: t(
      'constants.course.eStatusTagBox.underReviewDescription',
      '異動中',
    ),
    style: {
      backgroundColor: '#F9C80229',
      color: '#B78103',
    },
  },
  [ESTATUS_TAG.INCOMING]: {
    key: 'incoming',
    description: t(
      'constants.course.eStatusTagBox.incomingDescription',
      '即將開始',
    ),
    style: {
      backgroundColor: '#FF5630',
      color: '#FFFFFF',
    },
  },
  [COURSE_INTERVAL_STATUS.PROCESSING]: {
    key: 'processing',
    description: t(
      'constants.course.eStatusTagBox.processingDescription',
      '進行中',
    ),
    style: {
      backgroundColor: '#FF5630',
      color: '#FFFFFF',
    },
  },
  [ESTATUS_TAG.WAITING_GIVE_BACK]: {
    key: 'waitingGiveBack',
    description: t(
      'constants.course.eStatusTagBox.waitingGiveBackDescription',
      '待課後回饋',
    ),
    style: {
      backgroundColor: '#02A4EA29',
      color: '#015FA8',
    },
  },
};

export const COURSE_ISSUE_TEXT = {
  [COURSE_ISSUE.NONE]: '',
  [COURSE_ISSUE.OTHER]: t(
    'constants.course.courseIssueText.other',
    '異動原因：其他',
  ),
  [COURSE_ISSUE.TEACHER_TAKE_LEAVE]: t(
    'constants.course.courseIssueText.teacherLeave',
    '異動原因：老師無法到課',
  ),
  [COURSE_ISSUE.STUDENT_TAKE_LEAVE]: t(
    'constants.course.courseIssueText.studentLeave',
    '異動原因：學生無法到課',
  ),
  [COURSE_ISSUE.STUDENT_TAKE_LEAVE_WITHIN_8_HOURS]: t(
    'constants.course.courseIssueText.studentLeaveWithin8Hours',
    '異動原因：學生臨時無法到課',
  ),
  [COURSE_ISSUE.TEACHER_TAKE_LEAVE_TOO_LATE]: t(
    'constants.course.courseIssueText.teacherLeaveTooLate',
    '異動原因：老師於24時內無法到課',
  ),
  [COURSE_ISSUE.TEACHER_TAKE_LEAVE_BY_CIP]: t(
    'constants.course.courseIssueText.teacherLeaveByCip',
    '異動原因：學生 8 小時內無法到課 (原民會) 且老師無法到課',
  ),
  [COURSE_ISSUE.TEACHER_TAKE_LEAVE_TOO_LATE_BY_CIP]: t(
    'constants.course.courseIssueText.teacherLeaveTooLateByCip',
    '異動原因：學生 8 小時內無法到課 (原民會) 且老師臨時無法到課',
  ),
  [COURSE_ISSUE.STUDENT_TAKE_LEAVE_TOO_LATE]: t(
    'constants.course.courseIssueText.studentLeaveTooLate',
    '異動原因：學生臨時無法到課',
  ),
} as const;

export const UNUSUAL_ACTION_CONDITION = [
  COURSE_ISSUE.TEACHER_TAKE_LEAVE,
  COURSE_ISSUE.STUDENT_TAKE_LEAVE,
  COURSE_ISSUE.STUDENT_ASK_TRANSFER,
  COURSE_ISSUE.STUDENT_ASK_SUBSTITUTE,
  COURSE_ISSUE.STUDENT_ASK_CANCEL,
  COURSE_ISSUE.STUDENT_TAKE_LEAVE_WITHIN_8_HOURS,
  COURSE_ISSUE.TEACHER_TAKE_LEAVE_TOO_LATE,
  COURSE_ISSUE.STUDENT_TAKE_LEAVE_TOO_LATE,
  COURSE_ISSUE.TEACHER_TAKE_LEAVE_BY_CIP,
  COURSE_ISSUE.TEACHER_TAKE_LEAVE_TOO_LATE_BY_CIP,
] as const;

export enum COURSE_LINK_TYPE {
  SYNC_MULTIPLE = 'sync-multiple',
  SYNC_SINGLE = 'sync-single',
  SYNC_STREAMING = 'sync-streaming',
}
